import { type Database } from '@/types/supabase'

export const uploadTables: UploadTableName[] = [
  'germination',
  'oil_content',
  'protein_content',
  'seed_weights',
  'storage_behaviour',
]

// type which is key of Database['public']['Tables']if key matching any of | 'germination' | 'oil_content' | 'protein_content' | 'seed_weights' | 'storage_behaviour'
export type UploadTableName = {
  [K in keyof Database['public']['Tables']]: K extends
    | 'germination'
    | 'oil_content'
    | 'protein_content'
    | 'seed_weights'
    | 'storage_behaviour'
    ? K
    : never
}[keyof Database['public']['Tables']]
